<template>
  <div class="tier-container">
    <h1 class="tier-header">{{ pageTitle }}</h1>
    <div class="tier-content">
      <SessionView
        v-if="currentView === 'sessionView'"
        :sessions="filteredSessions"
        :loading="loading"
        :selectedAlbum="selectedAlbum"
        :handleAlbumClicked="handleAlbumClicked"
        :nowListeningVisible="nowListeningVisible"
        :nowListeningSession="nowListeningSession"
        :hasNext="hasNext"
        :loadingMore="loadingMore"
        :error="error"
        :searchQuery="searchQuery"
        :searchMode="searchMode"
        :isSearchActive="isSearchActive"
        :searchLoading="loading"
        :performSearch="performSearch"
        :clearSearch="clearSearch"
        @retry="loadMoreSessions"
      />
      <tierRow v-else />
    </div>
  </div>
</template>

<script>
import { toRefs, watchEffect, computed } from 'vue';
import { useSessionView } from '../composables/useSessionView';
import SessionView from './SessionView.vue';
import tierRow from './tierRow.vue';

export default {
  name: 'TierContainer',
  components: {
    SessionView,
    tierRow
  },
  props: {
    defaultView: {
      type: String,
      default: 'sessionView'
    }
  },
  setup(props) {
    const { defaultView } = toRefs(props);
    
    const {
      sessions,
      loading,
      currentView,
      toggleView,
      selectedAlbum,
      handleAlbumClicked,
      nowListeningVisible,
      nowListeningSession,
      filteredSessions,
      hasNext,
      loadingMore,
      error,
      loadMoreSessions,
      // Search functionality
      searchQuery,
      searchMode,
      isSearchActive,
      searchResults,
      performSearch,
      clearSearch
    } = useSessionView();

    // Set initial view based on props reactively
    watchEffect(() => {
      if (defaultView.value && currentView.value !== defaultView.value) {
        currentView.value = defaultView.value;
      }
    });

    // Page title based on current view
    const pageTitle = computed(() => {
      return currentView.value === 'sessionView' ? 'Sessions' : 'Tierlist';
    });

    return {
      sessions,
      loading,
      currentView,
      toggleView,
      selectedAlbum,
      handleAlbumClicked,
      nowListeningVisible,
      nowListeningSession,
      filteredSessions,
      pageTitle,
      hasNext,
      loadingMore,
      error,
      loadMoreSessions,
      // Search functionality
      searchQuery,
      searchMode,
      isSearchActive,
      searchResults,
      performSearch,
      clearSearch
    };
  }
};
</script>

<style scoped>
.tier-container {
  margin: 0 auto; 
  padding: 20px;
  background-color: #292929;
  border-radius: 8px; 
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

h1 {
  margin: 0!important;
}

.tier-header {
  text-align: left;
  font-size: 38px;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #ffffff; /* Dark grey for contrast */
}

.tier-content {
  /* No extra styles needed, but here for future extension */
}
@media (max-width: 768px) {
  .tier-container {
    padding: 10px;
  }

  .tier-header {
    font-size: 28px;
    text-align: center;
  }

  .nav-bar {
    flex-direction: column;
    gap: 10px;
    padding: 10px 0;
    border-radius: 0;
  }
  .nav-bar a {
    width: 100%;
    text-align: center;
    font-size: 1rem;
    padding: 12px 0;
  }
}

@media (max-width: 600px) {
  .tier-container {
    padding: 12px; /* Increased from 6px for better mobile spacing */
    border-radius: 8px; /* Keep some border radius */
    box-shadow: 0 2px 8px rgba(0,0,0,0.1); /* Subtle shadow */
    margin: 8px; /* Add margin to prevent edge touching */
  }
  .tier-header {
    font-size: 22px;
    text-align: center;
    padding: 4px 0;
  }
  .view-toggle {
    flex-direction: column;
    gap: 6px;
    margin-bottom: 12px;
  }
  .view-toggle button {
    width: 100%;
    padding: 8px 0;
    font-size: 15px;
  }
  .tier-content {
    padding: 0;
  }
  .nav-bar {
    text-align: center;
    margin-top: 12px;
  }
}
</style>
